import { useMutation } from '@tanstack/react-query'

import { signInRequest, SignInData, SignInResponse } from '~services'

export function useSignIn() {
  const {
    mutateAsync: signInUser,
    isLoading,
    isError,
    error,
  } = useMutation<SignInResponse, unknown, SignInData>(signInRequest)
  return { signInUser, isLoading, isError, error }
}
